module.exports = __webpack_public_path__ + "static/media/bourseauxmobiliers.6367a523.jpeg";